var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.className, _vm.alignClassName, _vm.typeClassName]},[(_vm.checkmark)?_c('span',{class:_vm.checkmarkClassName}):(_vm.text)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }